const ADMINS_ROUTES = {
  path: '/admins',
  component: () => import('@/pages/Admins/AdminsPagesContainer.vue'),
  children: [
    {
      path: '',
      name: 'admins.index',
      component: () => import('@/pages/Admins/AdminsPage.vue'),
    },
    {
      path: 'create',
      name: 'admins.create',
      component: () => import('@/pages/Admins/AdminFormPage.vue'),
    },
    {
      path: ':id/edit',
      name: 'admins.edit',
      component: () => import('@/pages/Admins/AdminFormPage.vue'),
    },
  ],
};

export default ADMINS_ROUTES;
